// extracted by mini-css-extract-plugin
export default {"root":"bCPaY69T2oHY45euFRTD","placeHolderShimmer":"MEYIOBZGNUwt1weAHGcw"};